module.exports = __webpack_public_path__ + "img/cloth_g1_item_11.2c98ea96.svg";